export default "__VITE_ASSET__D4efUfTL__"